import { render } from "./ApprovalFilterChips.vue?vue&type=template&id=1b87d194&scoped=true"
import script from "./ApprovalFilterChips.vue?vue&type=script&lang=js"
export * from "./ApprovalFilterChips.vue?vue&type=script&lang=js"

import "./ApprovalFilterChips.vue?vue&type=style&index=0&id=1b87d194&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b87d194"]])

export default __exports__